import { TPage } from 'common/types/global';
import { createContext, useContext } from 'react';

export interface GlobalConfig {
  pageType: TPage;
  brand: string;
  apiURL: string;
  envURL: string;
  isLocal: boolean;
  isUnknowCustomer?: boolean;
}

const GlobalConfigContext = createContext<GlobalConfig>({} as GlobalConfig);
GlobalConfigContext.displayName = 'GlobalStateContext';

export const { Provider: GlobalConfigProvider } = GlobalConfigContext;

const useGlobalConfig = () => useContext(GlobalConfigContext);
export default useGlobalConfig;
